import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {UserImpl} from "../../shared/services/user-impl.service";
import {inject} from "@angular/core";
import {AuthService} from "../resources/auth.service";
import {CookieService} from "../services/cookie.service";

/**
 * Гард аутентификации.
 *
 * Пропускает, если пользователь авторизован или есть валидный токен в куках (с последующим парсингом).
 * В противном случае сохраняет адрес перенаправления и переводит на страницу логина.
 */
export const authGuard: CanActivateFn = (route, state) => {
  let user: UserImpl = inject(UserImpl)
  let authService: AuthService = inject(AuthService)
  let router: Router = inject(Router)
  let cookieService = inject(CookieService)

  let checkRedirect: () => true | UrlTree = () => {
    let redirectUrl = authService.getRedirectUrl
    if (redirectUrl) {
      authService.setRedirectUrl = null
      return router.parseUrl(redirectUrl)
    } else {
      authService.setRedirectUrl = null
      return true
    }
  }

  if (user.token) {
    return true;
  } else {
    let token: string | null = cookieService.getCookie('auth')
    if (token) {
      authService.parseToken(token)
      return checkRedirect()
    } else {
      authService.setRedirectUrl = state.url
      return router.parseUrl('login')
    }
  }
}
